import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {contentSelector} from "../../ducks/content";
import Product from "../Product";

function RootProducts({content}) {
  return <Product product={content} />;
}

RootProducts.propTypes = {
  content: PropTypes.object
};

export default connect((state) => ({
  content: contentSelector(state)
}))(RootProducts);
